import { render, staticRenderFns } from "./DiagnosticoReparacion.vue?vue&type=template&id=6c12b48a&scoped=true"
import script from "./DiagnosticoReparacion.vue?vue&type=script&lang=js"
export * from "./DiagnosticoReparacion.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoReparacion.vue?vue&type=style&index=0&id=6c12b48a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c12b48a",
  null
  
)

export default component.exports